var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "root-contrast" },
    [
      _c("route-name", { attrs: { propsRouteName: "合同关键词抽取" } }),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("div", { staticClass: "extract" }, [
            _c("div", { staticClass: "upload-box" }, [
              _c("p", { staticStyle: { color: "#222" } }, [
                _vm._v("上传合同：")
              ]),
              _c(
                "div",
                { staticClass: "upload" },
                [
                  _c("img", {
                    attrs: {
                      src: "/images/AISmart/icon/group.png",
                      width: "49px",
                      height: "47px",
                      alt: ""
                    }
                  }),
                  _c(
                    "el-upload",
                    {
                      ref: "exUpload",
                      staticClass: "upload-bth",
                      attrs: {
                        action: "#",
                        accept: ".pdf,.doc,.docx",
                        limit: 1,
                        "auto-upload": false,
                        "on-exceed": _vm.exceed,
                        "on-change": _vm.fileChange,
                        "before-upload": _vm.fileExtract
                      }
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small", type: "danger", plain: "" } },
                        [_vm._v("选择文件")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "span",
                    { staticStyle: { color: "#999", "margin-top": "10px" } },
                    [
                      _vm._v(
                        "可支持\n            .pdf、.doc、.docx、格式文件，上传单个文件大小不超过30M。"
                      )
                    ]
                  )
                ],
                1
              )
            ]),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "danger" },
                    on: {
                      click: function($event) {
                        _vm.docTypeVisi = true
                      }
                    }
                  },
                  [_vm._v("开始抽取")]
                )
              ],
              1
            )
          ]),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "开始抽取",
                width: "30%",
                visible: _vm.docTypeVisi
              },
              on: {
                "update:visible": function($event) {
                  _vm.docTypeVisi = $event
                }
              }
            },
            [
              _c(
                "el-form",
                { ref: "tempForm", attrs: { model: _vm.form } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "选择合同类型",
                        prop: "docType",
                        rules: {
                          required: true,
                          message: "请选择合同类型",
                          trigger: "blur"
                        }
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择合同类型" },
                          model: {
                            value: _vm.form.docType,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "docType", $$v)
                            },
                            expression: "form.docType"
                          }
                        },
                        _vm._l(_vm.extractTypes, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.docTypeVisi = false
                        }
                      }
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.loadingBtn },
                      on: { click: _vm.extractDoc }
                    },
                    [_vm._v("确 定")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b25896dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b25896dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/smartDoc/docExtract/extract.vue
// module id = j2GE
// module chunks = 176